<template>
    <div>
        <!-- banner -->
        <top-block></top-block>

        <!-- 通知公告 -->
        <!-- <notice></notice> -->

        <!-- 项目服务流程 -->
        <!-- <project-process></project-process> -->

        <!-- TipDM建模平台 -->
        <modeling-platform></modeling-platform>

        <!-- 项目案例 -->
        <case></case>

        <!-- 行业服务 -->
        <industry-services></industry-services>

        

    </div>
</template>
<script>
    // new Tab('#hyfu .hds li','#hyfu .bds > div',1,"click",1000);
    // new Tab('#lwkhycfx .tabHd li','#lwkhycfx .tabBd > div',1,"click",1000,"autoplay","active");
    // new Tab('#ptjs .tabHd li','#ptjs .tabBd > div',1,"click",1000,"autoplay","active");
    // new Tab('#tipdmpt .hds li','#tipdmpt .bds > div',1,"click",1000);

    import {
        TopBlock,
        ProjectProcess,
        Case,
        IndustryServices,
        ModelingPlatform
    } from './components';
    import {Notice} from '@/pages/frontend/components';

    export default {
        name: 'project',
        components: {
            TopBlock,
            ProjectProcess,
            Case,
            IndustryServices,
            ModelingPlatform,
            Notice,
        }
    };

</script>
<style scoped>
    @import "~@/pages/frontend/assets/css/project.css";
</style>